import * as React from "react";

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { StackedGraphBar } from "../models/dataModels";


interface AccesosGraphProps {
    data: any[];
    bars: StackedGraphBar[];
}

export function AccesosContenidoGraph(props: AccesosGraphProps): JSX.Element {
    return <div className={"grafico_accesos" }>
        <ResponsiveContainer className="mt-lg"  width="100%">
            <BarChart
                data={props.data}

            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dia" ticks={['']} />
                <YAxis />
                <Legend />
                <Tooltip labelFormatter={t => t} />
                {props.bars != null && props.bars.map((bar, index) => {
                    return <Bar width={100} key={index} stackId="a" dataKey={bar.name} name={bar.name} fill={bar.rgbColor} />
                })}
            </BarChart>
        </ResponsiveContainer>
    </div>;
}
